export default __webpack_public_path__ + "static/media/lynnGameplay3.57fe3f10.png";